<div class="lightTheme">
  <div *ngIf="isLoading" class="svg-loader"></div>
  <div *ngIf="isModelErrorApp || isModelErrorService || isModelErrorAPI || isModelErrorOps" class="alert alert-danger errorMsg" role="alert">
    <span class="pointer" (click)="removeErrorMessage()" (keydown)="removeErrorMessage();"><mat-icon class="action-icon-delete"></mat-icon></span>
    {{modelErrorMessage}}
  </div>
  <div class="d-flex flex-row page-header">
    Model Management
    <button *ngIf="!isModelErrorApp && globals.groups.includes('PlatformAdminGroupId')" (click)="openDialog('addModel', element)" matTooltip="Add Model" matTooltipPosition="right" class="btn actionBtn add p-0">&nbsp;</button>
  </div>

  <div class="d-flex search_filter_area ">
    <div id="searchBar" class="d-inline-block">
      <input type="text" class="form-control" (keyup)="applyFilter($event.target.value)" placeholder="Search">
      <span class="searchIcon"><mat-icon aria-hidden="false" aria-label="search">search</mat-icon></span>
    </div>
    <div class="col-8 col-sm-8 col-md-8 col-lg-8 regularText">
      <mat-chip-listbox #chipList>
        <mat-chip-option *ngFor="let element of selectedFilters" [removable]="true" (removed)="remove(element)">
          {{globalService.replaceDisplayText(element.selectedFieldName) + " " + element.selectedCondition + " " + element.selectedValue}}
          <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
        </mat-chip-option>
      </mat-chip-listbox>
    </div>
    <div class="tbl_head_action float-right">
      <span class="filterIcon" matTooltip="Add Filter" placement="left-top" [ngbPopover]="addFilter" #popOver="ngbPopover" popoverTitle="Add Filter" autoClose="outside" popoverClass="popClassWidth"></span>
      <span class="exportIcon" matTooltip="Export to Excel" 
      (click)="exporterModel.exportTable('xlsx', {fileName:'ModelManagement', sheet: 'ModelManagement'})"
      (keydown)="exporterModel.exportTable('xlsx', {fileName:'ModelManagement', sheet: 'ModelManagement'});"
      ></span>
    </div>
  </div>

  <div class="d-flex flex-column modelTable">
      <mat-table matTableExporter [dataSource]="modelListDetails" matSort matSortActive="name​​"
                 matSortDirection="asc" #exporterModel="matTableExporter" hiddenColumns="[5]">
        <ng-container matColumnDef="modelName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.modelName}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="modelTypeName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Model Type</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.modelTypeName}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="modelVersion">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Version </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.modelVersion}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="businessDescription">
          <mat-header-cell *matHeaderCellDef> Description</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.businessDescription}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="businessFunctionTypeName">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Business Function</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.businessFunctionTypeName}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef class="mat-column-action"><span class="ml4">Action</span></mat-header-cell>
          <mat-cell class="tbl_action" *matCellDef="let element; let i = index;">
            <button class="actionIcon  pointer" matTooltip="View" mat-icon-button (click)="openDialog('viewModel', element)">
              <mat-icon class="action-icon-view"></mat-icon>
            </button>
            <button *ngIf="globals.groups.includes('PlatformAdminGroupId')" class="actionIcon pointer" matTooltip="Edit"
                    mat-icon-button (click)="openDialog('editModel', element)">
              <mat-icon class="action-icon-edit"></mat-icon>
            </button>
            <button class="actionIcon  pointer" matTooltip="Test" mat-icon-button (click)="openModelExec(element)">
              <mat-icon class="action-icon-test"></mat-icon>
            </button>
            <button *ngIf="globals.groups.includes('PlatformAdminGroupId')" class="actionIcon pointer" (click)="deleteModel(element)" matTooltip="Delete" mat-icon-button>
              <mat-icon class="action-icon-delete"></mat-icon>
            </button>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{ 'selected': selection.isSelected(row)}"></mat-row>
      </mat-table>
      <div *ngIf="(modelListDetails.data.length === 0) && (!isLoading)" class="emptyRepoMsg">
        <span> There are no records to display.</span>
      </div>
      <mat-paginator #paginator [pageSizeOptions]="[10,20,30]" [pageSize]="10" [hidden]="!modelListDetails.data.length">
      </mat-paginator>
  </div>
  <div class="clearfix"></div>
  <ng-template #addFilter><app-add-filter [filterList]="filterList" [selectedFilters]="selectedFilters" (filterResponse)="filterResponse($event)"></app-add-filter></ng-template>
</div>
